import 'screens/BrandKits/components/SourceMaterialModal/validation/validationSchema'
import * as yup from 'yup'

export const validationSchema = yup
  .mixed<File>()
  .required('File is required')
  .maxFileSize(1024 * 1024 * 1024)
